import React from "react";
import * as S from "./Radio.styles";

const RadioUI = (props) => {
  return <S.Radiobox>{props.children}</S.Radiobox>;
};

export default RadioUI;
